import { styled } from '../../Utilities';
import { DetailsRowBase } from './DetailsRow.base';
import { getStyles } from './DetailsRow.styles';
export var DetailsRow = styled(DetailsRowBase, getStyles, undefined, {
    scope: 'DetailsRow'
});
//# sourceMappingURL=DetailsRow.js.map